import { render, staticRenderFns } from "./HeaderDropdownAccnt.vue?vue&type=template&id=2552335a"
import script from "./HeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./HeaderDropdownAccnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports